import axios from '@/config/backend'

export default {
    login({ rootState, commit, dispatch }, user) {
        return new Promise((resolve, reject) => {
            user.firebase = rootState.firebaseToken
            try {
                axios
                    .post(`/${rootState.lang}/tokens`, user)
                    .then((response) => {
                        if (
                            !response.data.token ||
                            response.data.token.length <= 0
                        ) {
                            reject('Token not found')
                        }

                        var token = response.data.token
                        commit('setToken', token)
                        commit('setUser', response.data.user)
                        commit('setCompany', response.data.user.company)
                        commit('setIsConnected', true)

                        window.localStorage.setItem('token', token)

                        dispatch('initialiseStore', null, { root: true })

                        resolve()
                    })
                    .catch((error) => {
                        reject(error)
                    })
            } catch (error) {
                reject(error)
            }
        })
    },
    register({ rootState }, user) {
        return new Promise((resolve, reject) => {
            user.firebase = rootState.firebaseToken
            try {
                axios
                    .post(`/public/register`, user)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            } catch (error) {
                reject(error)
            }
        })
    },
    forgotPassword({ rootState, state }, email) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/public/forgot-password`, {
                    email: email,
                    client_url: rootState.vueAppBaseUrl
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    resetPassword({ state }, user) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/public/reset-password`, user)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    logout({ commit }) {
        localStorage.clear()
        commit('setIsConnected', false)

        return new Promise((resolve, reject) => {
            axios
                .get(`/logout`)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getIsPushNotif({ rootState }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/${rootState.lang}/pushNotifications`, {
                    params: {
                        firebase: rootState.firebaseToken
                    }
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    sendIsPushNotif({ rootState, commit }, content) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/${rootState.lang}/pushNotifications`, {
                    isNotifActivated: content.value,
                    firebase: rootState.firebaseToken
                })
                .then((response) => {
                    commit('setIsPushNotifActived', content.value)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
